<app-layout></app-layout>
<div style="padding-bottom: 2em;">
    <router-outlet></router-outlet>
</div>